export default function (to, from, next) {
    const user = JSON.parse(localStorage.getItem('user'));

    if (user) {
        if (user.email_verified_at) {
            next();
        } else {
            next({
                path: '/email/verify/' + user.id
            });
        }

    } else {
        next({
            path: '/login',
            query: {
                redirect: to.fullPath
            }
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/auth.js